import {ReactComponent as USFlag} from '../../assets/us-flag.svg'
import {ReactComponent as EUFlag} from '../../assets/eu-flag.svg'

type BEIngestStatus = 'New' | 'Running' | 'Done' | 'Aborted' | 'Error' | 'Stranded'
type FEIngestStatus = 'Loading' | 'Waiting' | 'Skipped' | 'Sent'
export type IngestStatus = BEIngestStatus | FEIngestStatus

type ColorDictionary = {
    [key in IngestStatus]?: string;
  };
export const STATUS_COLOR: ColorDictionary = {
    'Waiting': 'grey',
    'Aborted': 'orange',
    'Error': 'red',
    'Stranded': 'red'
}

export const activeIngestStatus = ['Queued', 'Processing']
export const PENDING_DELETION_STATUS = 'Pending Deletion'
// Statuses whose rows we refuse to select: mid-ingest, or already handed to the delete task.
// ponytail: pending-deletion rows are unselectable, so a stuck deletion can't be retried from the UI
// even though the BE re-submits the task on a repeat request. Drop the status from this list if
// stuck documents actually turn up.
export const unselectableStatus = [...activeIngestStatus, PENDING_DELETION_STATUS]

export const regions = 
[{ value: 'US', label: 'US', FlagImg: USFlag, title: 'US Server' },
 { value: 'EU', label: 'EU', FlagImg: EUFlag, title: 'EU Server' }]

// keep vision for backward compatibility until all customers have migrated to the other methods
export const PDF_READ_METHODS = ['legacy', 'msr', 'vision','msr_vision'] as const;
export type PdfReadMethod = (typeof PDF_READ_METHODS)[number];
export const PDF_READ_METHOD_LABELS: Record<PdfReadMethod, string> = {
  'legacy': 'Basic',
  'msr': 'MSR',
  'vision': 'Vision',
  'msr_vision': 'MSR & Vision'
}

export const LLM_PROVIDERS = ['Azure OpenAI', 'OpenAI'] as const;
export type LLMProvider = (typeof LLM_PROVIDERS)[number];

export const LLM_MODELS = ['gpt-4', 'gpt-4o', 'gpt-5.6-terra'] as const;
export type LLMModel = (typeof LLM_MODELS)[number];

export const AMBIGUITY_LLM_MODELS = ['gpt-4o', 'gpt-4o-mini'] as const;
export type AmbiguityLLMModel = (typeof AMBIGUITY_LLM_MODELS)[number];

export const EMBEDDING_MODELS = ['text-embedding-ada-002', 'text-embedding-3-large'] as const;
export type EmbeddingModel = (typeof EMBEDDING_MODELS)[number];

export const EMBEDDING_MODELS_CATALOG: Record<PdfReadMethod, Record<LLMProvider, EmbeddingModel[]>> = {
    'legacy': {
        'Azure OpenAI': ['text-embedding-3-large', 'text-embedding-ada-002'],
        'OpenAI': ['text-embedding-3-large', 'text-embedding-ada-002']
    },
    'msr': {
        'Azure OpenAI': ['text-embedding-3-large'],
        'OpenAI': ['text-embedding-3-large']
    },
    'msr_vision': {
        'Azure OpenAI': ['text-embedding-3-large'],
        'OpenAI': ['text-embedding-3-large']
    },
    'vision': {
        'Azure OpenAI': ['text-embedding-3-large'],
        'OpenAI': ['text-embedding-3-large']
    }
};

export type CustomPromptScope = 'customer' | 'tag'

export type MigrationStatus = 'None' | 'Initializing' | 'InProgress' | 'Complete' | 'Aborted' | 'Failed' | 'Swapping'
